import type { IDLProduct } from '~/types/dataLayer';
import type { ICartLine } from '~/modules/cart/types/cart-types';

export const extractBrandFromName = (name: string): string => {
  return name.split(' ')[0] ?? '';
};

export const extractVariant = (params: {
  strap_color?: string | null;
  strap_width?: string | null;
  mechanism?: string | null;
}): string => {
  return [params.strap_color, params.strap_width]
    .filter(Boolean)
    .join('/') || params.mechanism || '';
};

export const mapGroupProductToDL = (params: {
  id: number;
  name: string;
  final_price: { amount: string };
  brand?: string;
  strap_color?: string | null;
  strap_width?: string | null;
  mechanism?: string | null;
  discount?: { amount?: string } | null;
  category?: string;
  position?: number;
  list?: string;
  category_id?: number;
  quantity?: number;
}): IDLProduct => {
  return {
    id: String(params.id),
    name: params.name,
    price: Number(params.final_price.amount),
    brand: params.brand || extractBrandFromName(params.name),
    category: params.category ?? '',
    variant: extractVariant(params),
    discount: params.discount?.amount ? Number(params.discount.amount) : undefined,
    position: params.position,
    list: params.list,
    category_id: params.category_id,
    quantity: params.quantity,
  };
};

export const mapCartLineToDL = (line: ICartLine, quantity?: number): IDLProduct => ({
  id: String(line.product_id),
  name: line.name,
  price: Number(line.final_price.amount),
  brand: extractBrandFromName(line.name),
  category: '',
  variant: '',
  quantity: quantity ?? line.quantity.amount,
  discount: line.discount?.amount ? Number(line.discount.amount) : undefined,
  xml_id: line.offer_external_key,
  url: line.url,
});
